interface IEmailValidationProps {
  email: string;
  incorrectEmail: string;
  emptyEmail: string;
}

interface IEmailValidationReturn {
  status: 'notOk' | 'vazio' | 'ok';
  message: string;
}

const emailValidation = ({
  email,
  emptyEmail,
  incorrectEmail,
}: IEmailValidationProps): IEmailValidationReturn => {
  if (email === '') {
    return {
      status: 'notOk',
      message: emptyEmail,
    };
  }
  const test = email.match(/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/g);
  if (test) {
    return {
      status: 'ok',
      message: '',
    };
  }
  return {
    status: 'notOk',
    message: incorrectEmail,
  };
};

export { emailValidation };
